<app-popover #op [trigger]="'hover'" [width]="'15rem'" [maxHeight]="'35vh'" [showScrollbar]="true"
    (onToggle)="handlePopoverToggle($event)">
    <ng-template #trigger>
        <span
            (click)="onTriggerClick($event)"
            class="text-xs rounded-full bg-orange-500 text-white px-2 py-1 cursor-pointer"
        >
            {{number}}
        </span>
    </ng-template>
    <ng-template #body>
        <div class="flex flex-col">
            @if(sourceData.label) {
            <div class="text-sm font-bold pb-2">
                {{sourceData.label}}
            </div>
            }
            <div class="text-xs overflow-y-auto">
                <markdown [data]="isExpanded
                    ? sourceData.sourceText +  ' [Page ' + sourceData.pageNum + ']'
                    : sourceData.sourceText.length < 70
                        ? sourceData.sourceText + ' [Page ' + sourceData.pageNum + ']'
                        : (sourceData.sourceText | truncate:70 : '... [Page ' + sourceData.pageNum + ']')">
                </markdown>
                <span class="flex items-center gap-2 mt-0.5">
                    @if(sourceData.sourceText.length > 70 && !isExpanded) {
                    <span class="text-blue-700 cursor-pointer underline" (click)="toggleText($event)">View More</span>
                    }
                    @if(sourceData.pageNum && !disableNavigation) {
                    <span
                        class="flex items-center text-gray-800 hover:text-blue-600 cursor-pointer transition-colors"
                        title="Open page in document"
                        (click)="navigateToSource($event)">
                        <app-icon type="external-link" size="xs" />
                    </span>
                    }
                </span>
            </div>
        </div>
    </ng-template>
</app-popover>
